import Vue from 'vue'
import './plugins/vuetify'
import App from './app'
import axios from 'axios'
import { Model } from 'vue-api-query'
import SnackbarModalUtils from '@/mixins/reusable_mixins/SnackbarModalUtils'
import { beforeRequest, errorRequest } from '@/services/InterceptorAxios'

// Format axios (check if user already authenticated)
axios.defaults.headers.common['Content-Type'] = 'application/json'
const token = localStorage.getItem('user-token')
if (token) {
    axios.defaults.headers.common['Authorization'] = token
}

// Add a request and response interceptor
axios.interceptors.request.use(beforeRequest, undefined)
axios.interceptors.response.use(undefined, errorRequest)
import permissions from './mixins/reusable_mixins/permissions'
Vue.mixin(permissions)

// Linked axios with app models
Model.$http = axios
Vue.use(axios)
Vue.mixin(SnackbarModalUtils)
Vue.config.productionTip = false

import VueBarcodeScanner from 'vue-barcode-scanner'
Vue.use(VueBarcodeScanner)

import colors from '@/mixins/Colors'
import router from './routes/router'

// Breadcrums:
import VueBreadcrumbs from 'vue-2-breadcrumbs'
Vue.use(VueBreadcrumbs, {
    template:
        '        <nav v-if="$breadcrumbs.length" aria-label="breadcrumb">\n' +
        '            <ol class="breadcrumb">\n' +
        '                <li v-for="(crumb, key) in $breadcrumbs" v-if="crumb.meta.breadcrumb" :key="key" class="breadcrumb-item active" aria-current="page">\n' +
        '                    <span class="breadcrum-span" v-if="crumb.path === $route.path || crumb.path + `/` === $route.path"> {{ crumb.meta.breadcrumb }} </span>\n' +
        '                    <router-link class="breadcrum-router-link" v-else :to="{ path: crumb.path }">{{ getBreadcrumb(crumb.meta.breadcrumb) }}</router-link>\n' +
        '                </li>\n' +
        '            </ol>\n' +
        '        </nav>',
})

import store from './store/store'
Vue.mixin({
    data: function() {
        return {
            colors: colors,
        }
    },
})

new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app')
